
import { Component, Vue } from "vue-property-decorator";

export interface IFilters {
  include_archived: boolean;
}

@Component({
  name: "CTestingsFilters"
})
export default class CTestingsFilters extends Vue {
  public show_filter: boolean = false;
  public filters: Map<string, boolean> = new Map();
  public filters_count: number = 0;

  public include_archived: boolean = false;

  public changeIncludeArchivedAFilter() {
    if (this.include_archived) {
      this.filters.set("include_archived", true);
    } else {
      this.filters.delete("include_archived");
    }

    this.filters_count = this.filters.size;

    this.apply();
  }

  public clearFilters() {
    this.include_archived = false;

    this.filters.delete("include_archived");

    this.filters_count = this.filters.size;

    this.apply();
  }

  private apply() {
    this.$emit("apply", {
      include_archived: this.include_archived
    });
  }
}
